import type { JSX } from 'react';

import { CloseIcon } from '@change/ds-icons';

import { Button, Text } from '@change/ds-core-ui/next';

import { Translate } from '@change-corgi/core/react/i18n';

import { useClosePetition } from './hooks/useClosePetition';

export function ClosePetition(): JSX.Element {
	const {
		actions: { handleClosePetition },
	} = useClosePetition();

	return (
		<>
			<div className="flex w-full flex-col">
				<Text className="mt-6" size="x-small" variant="heading">
					<Translate value="corgi.petition.edit.settings.close_petition.button" />
				</Text>
				<Text className="mt-3" variant="body">
					<Translate value="corgi.petition.edit.settings.close_petition.description" />
				</Text>
			</div>
			<div>
				<Button
					className="w-56 sm:mt-4 md:mt-8"
					leadingIcon={<CloseIcon />}
					variant="secondary"
					size="small"
					data-qa="close-petition-button"
					onClick={handleClosePetition}
				>
					<Translate value="corgi.petition.edit.settings.close_petition.button" />
				</Button>
			</div>
		</>
	);
}
